module.exports = __webpack_public_path__ + "img/file.531cf1fd.svg";